import { render, staticRenderFns } from "./ProjectPublicityInfo.vue?vue&type=template&id=714dca2c&scoped=true&"
import script from "./ProjectPublicityInfo.vue?vue&type=script&lang=js&"
export * from "./ProjectPublicityInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPublicityInfo.vue?vue&type=style&index=0&id=714dca2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714dca2c",
  null
  
)

export default component.exports